import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Input from "./Input";

export const CostList = ({  CardEdit, cards, SaveCard , DeleteCard }) => {
    const [costCards, setCostCards] = useState([...cards.filter(card => !card.paymentDeleted)])
    // const [costCards, setCostCards] = useState([...cards])
    const [formed, setFormed] = useState(true)
    const [notFormed, setNotFormed] = useState(true)
    const ToDate = (value) => {
      if ((value !== '') && (value)){
        value = value.slice(6, 10) + "-" + value.slice(3, 5) + "-" + value.slice(0, 2)
      }
      return value
    }
    const SetValueDate = (ind, value) => {
      if (value !== ''){
        value = value.slice(8, 10) + "." + value.slice(5, 7) + "." + value.slice(0, 4)
      }
      let newArr = [...costCards]
      newArr[ind].paymentDate = value
      setCostCards(newArr);
    }
    const SetValueUsluga = (ind, value) => {
      let newArr = [...costCards]
      newArr[ind].paymentUsluga = value
      setCostCards(newArr);
    }
    const SetValuePayed = (ind) => {
      let newArr = [...costCards]
      newArr[ind].paymentPayed = !newArr[ind].paymentPayed
      setCostCards(newArr);
    }
    useEffect(() => {
      setCostCards([...cards.filter(card => !card.paymentDeleted)])
    }, [cards])
  if (!cards.length) {
    return <p className="center">Карточек пока нет</p>;
  }
  return (
    <div>
      <div>
        <p>Статус счета: </p>
        <p>
          <label>
            <input onChange={()=>{
                setFormed(!formed)
            }} type="checkbox" className="black filled-in" checked={formed} />
            <span style={{color: "white"}} className="left badge green">Оплачен</span>
          </label>
        </p>
        <p>
          <label>
            <input onChange={()=>{
                setNotFormed(!notFormed)
            }} type="checkbox" className="black filled-in" checked={notFormed} />
            <span style={{color: "white"}} className="left badge red">Не оплачен</span>
          </label>
        </p>
      </div>
      <table>
        <thead>
          <tr>
            <th>Состояние</th>
            <th>Дата выставления счета</th>
            <th>Номер счета</th>
            <th>Сумма</th>
            <th>Наименование</th>
            <th>Услуга</th>
            <th>Дата оплаты</th>
            <th>Юрист</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {costCards.map((elem, index) => {
              if ((elem.paymentPayed && !formed) || (!elem.paymentPayed && !notFormed)){
                  return null
              }
            return (
              <tr key ={index}>
                <td>
                  {" "}
                  <span onClick={()=>{SetValuePayed(index)}}
                    className={"badge" + (elem.paymentPayed ? " green" : " red")}
                  ></span>
                  
                </td>
                <td style={{width:"10%"}}>{elem.date === '' ? '-' : elem.date}</td>
                <td>{elem.formedId === '' ? '-' : elem.formedId}</td>
                <td style={{width:"10%"}}>{elem.totalPrice === '' ? '-' : elem.totalPrice}</td>
                {/* <td>{(elem.name === '' ? elem.formData.clientType.fio : elem.name) === '' ? '-' : (elem.name === '' ? elem.formData.clientType.fio : elem.name)}</td>
                 */}
                <td>{(elem.formData.clientType.type === 'ф.л.' ? elem.name : elem.formData.clientType.type === 'ю.л.' ? elem.formData.clientType.name : '') === '' ? '-' : (elem.formData.clientType.type === 'ф.л.' ? elem.name : elem.formData.clientType.ofp === 'Иное' ? elem.formData.clientType.shortofp+" «"+elem.formData.clientType.name+"»" : elem.formData.clientType.ofp === 'ИП' ? elem.formData.clientType.ofp+" "+elem.formData.clientType.name : elem.formData.clientType.ofp+" «"+elem.formData.clientType.name+"»")}</td>
                <td>
                <Input
                  id={"cost"+"text"+index}
                  type="text"
                  SetValue={SetValueUsluga}
                  field={index}
                  value={elem.paymentUsluga ? elem.paymentUsluga : ''}
                />
                </td>
                <td>
                <Input
                  id={"cost"+"date"+index}
                  type="date"
                  SetValue={SetValueDate}
                  field={index}
                  value={ToDate(elem.paymentDate) ? ToDate(elem.paymentDate) : ''}
                />
                </td>
                <td>
                {elem?.urist === '' ? '-' : elem.urist}
                </td>
                <td>
                  <NavLink
                    onClick={() =>
                      {SaveCard(elem._id, elem.paymentUsluga, elem.paymentDate, elem.paymentPayed)}
                    }
                    to={"#"}
                  >
                    Сохранить
                  </NavLink>
                </td>
                <td>
                  <NavLink
                    onClick={() =>
                      {DeleteCard(elem._id, elem.paymentUsluga, elem.paymentDate, elem.paymentPayed, index)}
                    }
                    to={"#"}
                  >
                    Удалить
                  </NavLink>
                </td>
                {/* <td><Link to={`/short1vz/detail/${elem._id}`}>Открыть</Link></td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
